export const padLeft = (s, l = 10, c = ' ') => {
    s = String(s);
    while(s.length < l) s = c + s;

    return s;
}